import { useState } from "react";
import {
  Box, Typography, MenuItem, FormControl, Grid,
  ToggleButton, ToggleButtonGroup, TextField
} from "@mui/material";
import CandleStickChart from "./CandlestickChart";



function transformData(stockData) {
  const { dates, open, high, low, close } = stockData;
  return ([
    {
      data: dates.map((date, i) => ({
        x: new Date(date),
        y: [
          open[i].toFixed(2),
          high[i].toFixed(2),
          low[i].toFixed(2),
          close[i].toFixed(2),
        ],
      })),
    },
  ]);
}

const StockInsights = ({ stockData, historicalData }) => {
  const [period, setPeriod] = useState("1mo");
  const [selectedStock, setSelectedStock] = useState({});
  const [selectedHistoricalStock, setSelectedHistoricalStock] = useState({});

  const handlePeriodChange = (event) => {
    if (event.target.value) setPeriod(event.target.value);
    const historicalStock = historicalData.find((s) => s.symbol === selectedStock.tradingsymbol);
    const data = transformData(historicalStock["periods"][event.target.value]);
    setSelectedHistoricalStock(data);
  };

  const handleStockChange = (e) => {
    const selectedStock = stockData.find((s) => s.tradingsymbol === e.target.value);
    setSelectedStock(selectedStock);
    const historicalStock = historicalData.find((s) => s.symbol === e.target.value);
    const data = transformData(historicalStock["periods"][period]);
    setSelectedHistoricalStock(data);
  };



  return (
    <Box sx={{ p: 4, bgcolor: "white", color: "#2d4890" }}>
      <Typography variant="h4" gutterBottom>🔍 Stock Analysis</Typography>

      <FormControl sx={{ minWidth: 400, mb: 3 }}>
        <TextField
          select
          label="Select Stock"
          value={selectedStock.tradingsymbol}
          onChange={handleStockChange}
          fullWidth
          sx={{ mb: 4 }}
        >
          {stockData.map((stock) => (
            <MenuItem key={stock.tradingsymbol} value={stock.tradingsymbol}>
              {stock.tradingsymbol}
            </MenuItem>
          ))}
        </TextField>
      </FormControl>

      {selectedStock && Object.keys(selectedStock).length > 0 && (
        <>
          <Grid container spacing={4} sx={{ mb: 4 }}>
            <Grid item xs={6} md={3}>
              <Typography>Current Price</Typography>
              <Typography variant="h6">₹{selectedStock.current_value}</Typography>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography>Average Price</Typography>
              <Typography variant="h6">₹{selectedStock.average_price.toFixed(2)}</Typography>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography>Quantity</Typography>
              <Typography variant="h6">{selectedStock.quantity}</Typography>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography>Profit/Loss</Typography>
              <Typography variant="h6" sx={{ color: selectedStock.profit_loss >= 0 ? "lightgreen" : "red" }}>
                ₹{selectedStock.profit_loss.toFixed(2)} ({selectedStock.profit_loss_percent.toFixed(2)}%)
              </Typography>
            </Grid>
          </Grid>


          <Typography variant="h6" sx={{ mt: 3 }}>Advanced Metrics</Typography>
          <Grid container spacing={4}>
            <Grid item xs={6} md={3}>
              <Typography>Beta</Typography>
              <Typography>{selectedStock.beta}</Typography>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography>Alpha</Typography>
              <Typography>{selectedStock.alpha}%</Typography>
            </Grid>
          </Grid>
        </>
      )}
      <Box sx={{ mt: 5 }}>
        <Typography variant="h5">Historical Price</Typography>
        <ToggleButtonGroup
          value={period}
          exclusive
          onChange={handlePeriodChange}
          sx={{ my: 2 }}
          color="primary"
        >
          <ToggleButton value="1mo">1 Month</ToggleButton>
          <ToggleButton value="1y">1 Year</ToggleButton>
        </ToggleButtonGroup>

        {Object.keys(selectedHistoricalStock).length > 0 && <CandleStickChart series={selectedHistoricalStock}
          stock={selectedStock.tradingsymbol} period={period} />}




      </Box>
    </Box>
  );
};

export default StockInsights;
